export const REQUIRED =
  "[aria-required=true],input[type=radio],input[type=checkbox]";

export function setupValidation() {
  function checkIfAllRequiredFilled(event: Event) {
    const input = event.target as HTMLElement;

    const form = input.closest("form")! as HTMLFormElement;

    const invalidFields = [];
    const allFilled = [...form.querySelectorAll(REQUIRED)].every(
      (element: Element) => {
        if (element instanceof HTMLInputElement) {
          if (element.type === "checkbox") {
            if (!element.checked) return element.checked;
          }
          return element.value.length > 0;
        }

        if (element instanceof HTMLTextAreaElement) {
          return element.value.length > 0;
        }

        if (element instanceof HTMLSelectElement) {
          return element.selectedIndex > 0;
        }
      },
    );
    const sendButton = form.querySelector("[type=submit]") as HTMLButtonElement;
    if (allFilled) {
      sendButton.disabled = false;
    } else {
      sendButton.disabled = true;
    }
  }

  document.querySelectorAll(REQUIRED).forEach((element) => {
    element.addEventListener("change", checkIfAllRequiredFilled);
  });
}
